"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactIntl = require("react-intl");
var messages = (0, _reactIntl.defineMessages)({
  minCharactersPassword: {
    "id": "minCharactersPassword",
    "defaultMessage": "Minimum {value} {value, plural, one {character} other {characters}}"
  },
  lowercaseLettersPassword: {
    "id": "lowercaseLettersPassword",
    "defaultMessage": "{value} lowercase {value, plural, one {letter} other {letters}}"
  },
  uppercaseLettersPassword: {
    "id": "uppercaseLettersPassword",
    "defaultMessage": "{value} uppercase {value, plural, one {letter} other {letters}}"
  },
  nummbersInPassword: {
    "id": "nummbersInPassword",
    "defaultMessage": "{value} {value, plural, one {number} other {numbers}}"
  },
  nonAlphaInPassword: {
    "id": "nonAlphaInPassword",
    "defaultMessage": "{value} non-alphanumeric {value, plural, one {character} other {characters}} (!@$&, etc.)"
  }
});
var _default = exports["default"] = messages;
//# sourceMappingURL=messages.js.map